module.exports = __webpack_public_path__ + "img/package-black.66f5ded9.svg";